import React from 'react';
import { of } from 'rxjs';
import get from 'lodash.get';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as ConnectActions from '../../../store/shipstation-connect/ss-connect.actions';
import { DocumentType } from '../../../enums/document-type';

const messages = defineMessages({
  printingLabelSuccessTitle: {
    description: 'printEpics.printingLabelSuccessTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {Label} one {Label} other {Labels}}...',
    id: 'ZHXrpH',
  },
  printingLabelSuccessContent: {
    description: 'printEpics.printingLabelSuccessContent',
    defaultMessage: '{docCount, plural,=0 {Label} one {Label} other {Labels}} sent to {printerName}.',
    id: 'ShRRaF',
  },
  downloadLabelsStartedTitle: {
    description: 'printEpics.downloadLabelsStartedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {Label} one {Label} other {Labels}}...',
    id: 'o/Fzww',
  },
  downloadLabelsStartedContent: {
    description: 'printEpics.downloadLabelsStartedContent',
    defaultMessage: '{docCount, plural,=0 {Label} one {Label} other {Labels}} Download Started.',
    id: 'MkGsJa',
  },
  downloadLabelsCompletedTitle: {
    description: 'printEpics.downloadLabelsCompletedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {Label} one {Label} other {Labels}}...',
    id: 'Nle58c',
  },
  downloadLabelsCompletedContent: {
    description: 'printEpics.downloadLabelsCompletedContent',
    defaultMessage: '{docCount, plural,=0 {Label} one {Label} other {Labels}} Download Completed.',
    id: 'piUb6X',
  },
});

export const batchLabels = {
  id: DocumentType.BatchLabel.identifier,

  getDownloadStartedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadLabelsStartedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadLabelsStartedContent} values={{ docCount }} />,
  }),

  getDownloadCompletedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadLabelsCompletedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadLabelsCompletedContent} values={{ docCount }} />,
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: <FormattedMessage {...messages.printingLabelSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.printingLabelSuccessContent} values={{ docCount, printerName }} />,
  }),

  getPrintedSuccessObservable: (printJob) => {
    const printJobRequestId = get(printJob, 'requestId');
    return of(ConnectActions.printDocumentComplete(printJobRequestId));
  },
};
